import script from "./InvoicesTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoicesTableRow.vue?vue&type=script&setup=true&lang=js"

import "./InvoicesTableRow.vue?vue&type=style&index=0&id=3561b8b0&scoped=true&lang=css"
script.__scopeId = "data-v-3561b8b0"

export default script